import React from "react";
import GDataBaseProvider from "../../components/graph/GDataBaseProvider";
import BaseLayout from "../../components/layout/BaseLayout";
import TextContainer from "../../components/layout/TextContainer";
import PageHeader from "../../components/general/PageHeader";
import GDataZeroBaseFeeProvider from "../../components/graph/zerobasefee/GDataZeroBaseFeeProvider";
import InteractiveGraphControllerProvider from "../../components/graph/InteractiveGraphControllerProvider";
import GDataLoadingGuard from "../../components/graph/GDataLoadingGuard";
import ZeroBaseFeeGraph from "../../components/graph/zerobasefee/ZeroBaseFeeGraph";
import ZeroBaseFeeChannelPercentage from "../../components/graph/zerobasefee/ZeroBaseFeeChannelPercentage";
import ZeroBaseFeeCapacityPercentage from "../../components/graph/zerobasefee/ZeroBaseFeeCapacityPercentage";
import { ZeroBaseSettingsProvider } from "../../components/graph/zerobasefee/ZeroBaseFeeSettings";
import { ZeroBaseFeeDropdown } from "../../components/graph/zerobasefee/ZeroBaseFeeDropdown";



export default function GraphPage() {


  return (
    <div>
      <BaseLayout
        pageTitle="Zero base fee"
        seoDescription="Visualize all nodes with their channels that support #zeroBaseFee."
      >
        <PageHeader
          title="Zero Base Fee graph"
          description={<span>
            Visualize all nodes with their channels that support <a
              target="_blank"
              className="underline hover:text-viking-700"
              href="https://basefee.ln.rene-pickhardt.de/">
              #zeroBaseFee
            </a>.
          </span>}
        />

        <section className="">
          <TextContainer>
            <div className="text-base">
              <p>
                Rene Pickhardt and Stefan Richter found out that <a
                  href="https://arxiv.org/abs/2107.05322" target="_blank"
                  className="underline hover:text-viking-700"> finding
                  the cheapest Multipart Payment is an NP-complete problem</a> if 
                  a base fee is included in the fee function.
                If the base fee is dropped nodes can compute this optimization problem.
              </p>
              <p className="pt-1">Rene and Stefans new pathfinding algorithm (aka. <a
                href="https://twitter.com/aantonop/status/1403823353366994946" target="_blank"
                className="underline hover:text-viking-700">Pickhardt Payments</a>)
                would allow much larger amounts to be sent over the lightning network than what we currently see.</p>
              <p className="pt-2">This graph aims to visualize the support for <span className="font-bold">#zeroBaseFee</span> and therefore Pickhardt Payments.</p>
            </div>
          </TextContainer>
          <ZeroBaseSettingsProvider>
            <GDataBaseProvider >
              <GDataLoadingGuard>
                <TextContainer>

                  <div className="flex flex-wrap justify-around mb-12 pt-24">
                    <ZeroBaseFeeChannelPercentage />
                    <ZeroBaseFeeCapacityPercentage />
                  </div>
                </TextContainer>
                <GDataZeroBaseFeeProvider>
                  <InteractiveGraphControllerProvider>
                    <ZeroBaseFeeDropdown />
                    <ZeroBaseFeeGraph />

                  </InteractiveGraphControllerProvider>
                </GDataZeroBaseFeeProvider>
              </GDataLoadingGuard>
            </GDataBaseProvider>
          </ZeroBaseSettingsProvider>
        </section>

        <section>
          <TextContainer>
            <div className="mt-12">
              <h2 className="text-xl font-bold mb-2 text-gray-800"><span className="">FAQ</span></h2>

              <h2 className="font-bold text-base text-gray-600 mt-8 pb-2"><span className="">What do these colors indicate?</span></h2>
              <p>
                <span className="inline-block px-2 py-2" style={{ background: '#4cfaf8' }}></span> A blue channel has set its base fee to zero. A blue node has set at least 85% of its base fees to zero.
              </p>
              <p>
                <span className="inline-block px-2 py-2" style={{ background: '#daa058' }}></span> An orange channel has not set its base fee to zero. A orange node has less than 85% of its base fees set to zero.
              </p>

              {/* <h2 className="font-bold text-base text-gray-600 mt-8 pb-2"><span className="">Why do some nodes not have channels when I click on them</span></h2>
              <p>
                #zeroBaseFee is an initiative of Rene Pickhardt and Stefan Richter to drop the channel base fee to zero.
                For more information, checkout <a target="_blank"
                  className="underline hover:text-viking-700"
                  href="https://basefee.ln.rene-pickhardt.de/">drop the base with #zerobasefee</a>.
              </p> */}

              <h2 className="font-bold text-base text-gray-600 mt-8 pb-2"><span className="">How accurate are the indicated percentages?</span></h2>
              <p>
                <span className="code">Channels with #zeroBase</span> and <span className="code">Capacity with #zeroBase</span> are
                calculated based on channel updates starting from February 2021.
              </p>
              
              <h2 className="font-bold text-base text-gray-600 mt-8 pb-2"><span className="">What is #zeroBaseFee?</span></h2>
              <p>
                #zeroBaseFee is an initiative of Rene Pickhardt and Stefan Richter to drop the channel base fee to zero.
                For more information, checkout <a target="_blank"
                  className="underline hover:text-viking-700"
                  href="https://basefee.ln.rene-pickhardt.de/">drop the base with #zerobasefee</a>.
              </p>

            </div>
          </TextContainer>
        </section>

      </BaseLayout>
    </div >
  );
}
